<footer class="blog-footer">
  <div class="container">
    <div class="row">
      <!-- remove this offset sucka -->
      <!-- <div class="offset-md-2"></div> -->
      <ng-container *ngFor="let footerItem of footerItems; index as i">
        <!-- also this col-6 was a col-3 when we have more shit on this dank footer -->
        <div class="col-md-3 footer-item-container" [class.offset-md-2]="i % 3 == 0">
          <h5 class="footer-item-header text-white" *ngIf="footerItem.text">{{ footerItem.text }}</h5>
          <div class="footer-item-images mb-2">
            <ng-container *ngFor="let image of footerItem.images">
              <a *ngIf="image.route" [routerLink]="image.route" [attr.route]="image.route" title="{{ image.text }}">
                <img *ngIf="image.src" [src]="image.src" />
                <i *ngIf="image.iconClass" [ngClass]="image.iconClass" class="text-grey"></i>
              </a>
              <a *ngIf="image.externalLink" [href]="image.externalLink" title="{{ image.text }}" target="_blank">
                <img *ngIf="image.src" [src]="image.src" />
                <i *ngIf="image.iconClass" [ngClass]="image.iconClass" class="text-grey"></i>
              </a>
            </ng-container>
          </div>
          <ul *ngIf="footerItem.submenu" class="list-unstyled font-weight-light fs-13">
            <li *ngFor="let subItem of footerItem.submenu">
              <a
                class="text-white"
                *ngIf="subItem.route"
                [queryParams]="subItem.queryParams"
                [routerLink]="subItem.route"
                [attr.route]="subItem.route"
                title="{{ subItem.text }}"
              >
                <img *ngIf="subItem.src" [src]="subItem.src" />
                <i *ngIf="subItem.iconClass" [ngClass]="subItem.iconClass" class="text-grey"></i>
                {{ subItem.text }}
              </a>
              <a
                class="text-white"
                href
                *ngIf="subItem.externalLink"
                [href]="subItem.externalLink"
                title="{{ subItem.text }}"
                target="{{ subItem.targetBlank ? '_blank' : '' }}"
              >
                {{ subItem.text }}
              </a>
            </li>

            <li></li>
          </ul>
        </div>
      </ng-container>
    </div>
    <div class="footer-seperator"></div>
    <div class="text-center text-grey d-flex justify-content-center">
      <i class="icon-rubbl fs-25"></i>
      <span class="ml-2">&copy; Rubbl. inc</span>
    </div>
  </div>
</footer>
